module.exports = __webpack_public_path__ + "img/icon-person.371dcdf0.svg";